export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_clear',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'label_manage',
  'agent_manage',
  'team_manage',
  'inbox_manage',
  'automation_manage',
  'canned_response_manage',
  'macro_manage',
  'integration_manage',
  'webhook_manage',
  'agent_bot_manage',
  'assignment_policy_manage',
  'sla_manage',
  'campaign_manage',
  'custom_attribute_manage',
  'report_manage',
  'knowledge_base_manage',
  'inventory_manage',
  'openai_manage',
  'finance_manage',
  'billing_manage',
  'benefit360_query',
  'benefit360_reveal',
  'benefit360_admin',
  'benefit360_campaign_download',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const LABEL_PERMISSIONS = 'label_manage';

export const AGENT_PERMISSIONS = 'agent_manage';

export const TEAM_PERMISSIONS = 'team_manage';

export const INBOX_PERMISSIONS = 'inbox_manage';

export const AUTOMATION_PERMISSIONS = 'automation_manage';

export const CANNED_RESPONSE_PERMISSIONS = 'canned_response_manage';

export const MACRO_PERMISSIONS = 'macro_manage';

export const INTEGRATION_PERMISSIONS = 'integration_manage';

export const WEBHOOK_PERMISSIONS = 'webhook_manage';

export const AGENT_BOT_PERMISSIONS = 'agent_bot_manage';

export const ASSIGNMENT_POLICY_PERMISSIONS = 'assignment_policy_manage';

export const SLA_PERMISSIONS = 'sla_manage';

export const CAMPAIGN_PERMISSIONS = 'campaign_manage';

export const CUSTOM_ATTRIBUTE_PERMISSIONS = 'custom_attribute_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const INVENTORY_PERMISSIONS = 'inventory_manage';

export const OPENAI_PERMISSIONS = 'openai_manage';

export const FINANCE_PERMISSIONS = 'finance_manage';

export const BILLING_PERMISSIONS = 'billing_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
